import { render, staticRenderFns } from "./NeuralIconActive.vue?vue&type=template&id=fa2c1978&"
import script from "./NeuralIconActive.vue?vue&type=script&lang=js&"
export * from "./NeuralIconActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports